<template>
  <el-dialog
    append-to-body
    :title="dialogTitle"
    :visible="visible"
    width="520px"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="90px" size="mini">
      <el-form-item v-if="showRestrictionFields" label="限制类型" prop="block_type">
        <el-select
          v-model="form.block_type"
          placeholder="请选择"
          style="width: 100%"
          :disabled="disableTypeValue"
          @change="handleChangeType"
        >
          <el-option v-for="opt in typeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="showRestrictionFields" :label="typeValueLabel" prop="block_value">
        <el-input
          v-model="form.block_value"
          clearable
          :placeholder="`输入${typeValueLabel}，按下回车键或点击添加`"
          :disabled="disableTypeValue"
          @keydown.enter.native="handleAddValue"
        >
          <template #append>
            <el-button type="primary" size="small" @click="handleAddValue">添加</el-button>
          </template>
        </el-input>

        <!-- <el-select v-model="form.block_value" placeholder="请输入" style="width: 100%" allow-create multiple filterable>
        </el-select> -->
      </el-form-item>

      <el-form-item label="限制方式" prop="limit_type">
        <el-select v-model="form.limit_type" multiple placeholder="选择限制方式" style="width: 100%">
          <el-option v-for="opt in methodOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
      </el-form-item>

      <el-form-item label="备注" prop="reason">
        <el-input
          v-model="form.reason"
          type="textarea"
          :rows="3"
          maxlength="200"
          show-word-limit
          placeholder="输入备注"
        />
      </el-form-item>
      <el-form-item label="同时拉黑IP登录过的账号" label-width="200px" v-if="form.block_type !== 4">
        <el-switch
          :disabled="isEdit"
          v-model="form.isDisableAccounts"
          active-text="是"
          inactive-text="否"
          :active-value="true"
          :inactive-value="false"
        ></el-switch>
      </el-form-item>
    </el-form>
    <div class="block-value-list" v-if="blockVaueList.length > 0 && form.block_type !== 4">
      <div class="block-value-list-title">拉黑{{ typeValueLabel }}列表</div>
      <el-tag
        style="margin-right: 5px; margin-bottom: 5px"
        type="danger"
        size="mini"
        v-for="value in blockVaueList"
        :key="value"
        closable
        @close="handleRemoveValue(value)"
        >{{ value }}</el-tag
      >
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="handleClose">取消</el-button>
      <el-button size="mini" type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { loginLogApi } from '@/api/riskControl/loginLog'

export default {
  name: 'CreateBlackDialog',
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: null },
    typeOptions: { type: Array, default: () => [] },
    methodOptions: { type: Array, default: () => [] },
    // 预填后锁定“限制类型/值”（例如从会员概览一键拉黑）
    lockTypeValue: { type: Boolean, default: false },
    /** 会员概览拉黑账号：展示标题并隐藏限制类型/值 */
    accountPrefill: { type: Object, default: null },
  },
  data() {
    return {
      ipReg: /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
      blockVaueList: [],
      submitting: false,
      form: {
        id: undefined,
        block_type: '',
        block_value: '',
        limit_type: [],
        reason: '',
        isDisableAccounts: false,
      },
      rules: {
        block_type: [{ required: true, message: '请选择限制类型', trigger: 'change' }],
        block_value: [
          {
            validator: (rule, value, callback) => {
              const t = Number(this.form.block_type)
              // 2(IP) / 3(设备号)：校验列表是否为空（通过“添加”进入列表）
              if (t === 2 || t === 3) {
                if (!(Array.isArray(this.blockVaueList) && this.blockVaueList.length > 0)) {
                  return callback(new Error('请添加至少一个' + this.typeValueLabel))
                }
                if (t === 2) {
                  const invalid = this.blockVaueList.find(v => !this.ipReg.test(String(v).trim()))
                  if (invalid) return callback(new Error('存在不合法IP：' + invalid))
                }
                return callback()
                return callback(new Error('请添加至少一个' + this.typeValueLabel))
              }
              // 4(会员ID)：校验输入是否为空
              if (t === 4) {
                if (
                  (value != null && String(value).trim() !== '') ||
                  (Array.isArray(this.blockVaueList) && this.blockVaueList.length > 0)
                ) {
                  return callback()
                }
                return callback(new Error('请输入' + this.typeValueLabel))
              }
              return callback()
            },
            trigger: ['blur'],
          },
        ],
        limit_type: [{ type: 'array', required: true, message: '请选择限制方式', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  computed: {
    dialogTitle() {
      if (this.isEdit) return '编辑黑名单'
      const p = this.accountPrefill
      if (p) {
        const name = p.username != null && String(p.username).trim() !== '' ? String(p.username).trim() : '--'
        const uid = p.uid != null && String(p.uid).trim() !== '' ? String(p.uid).trim() : '--'
        return `拉黑账户-【${name}（${uid}）】`
      }
      return '添加黑名单'
    },
    /** 拉黑账号预制：新增且带 accountPrefill 时不展示类型/值 */
    showRestrictionFields() {
      return this.isEdit || !this.accountPrefill
    },
    isEdit() {
      return !!(this.row && this.row.id != null)
    },
    disableTypeValue() {
      return this.isEdit || this.lockTypeValue
    },
    typeValueLabel() {
      const opt = (this.typeOptions || []).find(o => o.value == this.form.block_type)
      return opt?.label || '限制值'
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) this.initForm()
      },
    },
    row: {
      deep: true,
      handler() {
        if (this.visible) this.initForm()
      },
    },
  },
  methods: {
    handleChangeType() {
      this.blockVaueList = []
    },
    handleAddValue() {
      if (!this.form.block_value) return
      const t = Number(this.form.block_type)
      if (t === 2) {
        const v = String(this.form.block_value).trim()
        if (!this.ipReg.test(v)) {
          this.$message.warning('请输入正确的IP格式')
          return
        }
        this.form.block_value = v
      }
      if (this.blockVaueList.includes(this.form.block_value)) {
        this.$message.warning(this.form.block_value + '已存在，请勿重复添加')
        return
      }
      this.blockVaueList.push(this.form.block_value)
      this.form.block_value = ''
      this.$nextTick(() => this.$refs.formRef?.validateField?.('block_value'))
    },
    handleRemoveValue(value) {
      this.blockVaueList = this.blockVaueList.filter(v => v !== value)
      this.$nextTick(() => this.$refs.formRef?.validateField?.('block_value'))
    },
    initForm() {
      const firstType = this.typeOptions?.[0]?.value || ''
      const r = this.row || {}
      const id = r.id
      const limit_type =
        typeof r.limit_type === 'string'
          ? r.limit_type.split(',').filter(Boolean)
          : Array.isArray(r.limit_type)
          ? r.limit_type
          : []

      const blockType = r.block_type || firstType
      const rawBlockValue = r.block_value || r.type_value || ''
      const parseValueList = value => {
        if (Array.isArray(value)) return value.map(v => String(v).trim()).filter(Boolean)
        if (value == null) return []
        const text = String(value)
        return text
          .split(/[,\n\r\t ]+/)
          .map(v => String(v).trim())
          .filter(Boolean)
      }

      this.form = {
        id,
        block_type: blockType,
        block_value: rawBlockValue,
        limit_type: limit_type || [],
        reason: r.reason || '',
        isDisableAccounts: false,
      }

      // 编辑/锁定类型值时：IP/设备号是通过 values 列表提交，需把现有 block_value 初始化到列表
      const t = Number(blockType)
      if (t === 2 || t === 3 || t === 4) {
        this.blockVaueList = parseValueList(rawBlockValue)
        this.form.block_value = ''
      } else {
        this.blockVaueList = []
      }

      this.$nextTick(() => this.$refs.formRef?.clearValidate?.())
    },
    handleResetForm() {
      this.form = {
        id: undefined,
        block_type: '',
        block_value: '',
        limit_type: [],
        reason: '',
        isDisableAccounts: false,
      }
      this.blockVaueList = []
    },
    handleClose() {
      this.handleResetForm()
      this.$emit('update:visible', false)
    },
    async handleSubmit() {
      const formRef = this.$refs.formRef
      if (!formRef) return

      formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const payload = {
            block_type: this.form.block_type,
            values: this.blockVaueList,
            limit_type: this.form.limit_type || [],
            reason: this.form.reason,
            is_block_player: this.form.isDisableAccounts,
          }
          if (this.form.block_type === 4) {
            delete payload.is_block_player
          }
          if (this.isEdit) {
            payload.id = this.form.id
            await loginLogApi.updateBlacklist(payload)
          } else {
            await loginLogApi.createBlacklist(payload)
          }
          this.$message.success(this.isEdit ? '编辑成功' : '拉黑成功')
          this.$emit('saved')
          this.handleClose()
        } catch (e) {
          this.$message.error(e?.message || '操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
  },
}
</script>
<style scoped>
.block-value-list {
  max-height: 150px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
.block-value-list-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
